import { useHistory, useLocation } from 'react-router';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalItem from '../../common/ModalItem/ModalItem';
import { Hidden } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import YellowButton from '../../common/YellowButton';
import { postSolution } from '../../../store/activitiesSlice';
import { changeErrorPopupState } from '../../../store/uiSlice';
import IsMobileContext from '../../../common/IsMobileContext';
import './admin-place-info.scss';
import AdminPayment from '../../admin/AdminPayment/AdminPayment';
import { completedRoutes } from '../../../common/constants';

const ContentSwitch = (props) => {
  const { desktopOption, content, placeId } = props;

  return (
    <Switch>
      <Route path={completedRoutes.adminPayment(placeId)}>
        <AdminPayment />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function AdminPlaceInfo(props) {
  const { state: { placeId } } = useLocation();
  const { t } = useTranslation();
  const history = useHistory();
  const isMobileDesign = useContext(IsMobileContext);

  const { places } = props;

  const placeData = places.filter((i) => {
    const { likengo_id: id } = i;
    return id === placeId;
  })[0];

  if (placeData === undefined) return null;

  const { name, address, balance } = placeData;
  const handlePayment = () => {
    history.push(completedRoutes.adminPayment(placeId), { placeId });
  };

  const handleChangePlace = () => {
    history.replace(completedRoutes.adminPlaces);
  };

  const content = (
    <div className="admin-place-info-cnt">
      <span className="name">{name}</span>
      <span className="address">{address}</span>
      <span className="place-balance">
            {t('placesGrid.balance')}:{' '}
        <span className="rubble">{balance}</span>
      </span>
      <div className="change-place" onClick={handleChangePlace}>
        {t('placesGrid.changePlace')}
      </div>
      <div className="get-pay-off-btn">
        <YellowButton hidden={false}
                      title={t('placesGrid.getUserPayment')}
                      handleClick={handlePayment}
        />
      </div>
    </div>
  );

  return (
    <ModalItem withBackButton={false}>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} placeId={placeId} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = state => ({
  places: state.places.data,
});

const actionCreators = {
  changeErrorPopupState: changeErrorPopupState,
  postSolution: postSolution,
};

export default connect(mapStateToProps, actionCreators)(AdminPlaceInfo);
